import { Navigate } from "react-router";
import { useGetMembersGroupQuery } from "../../../apis/MembersGroup.api";
import { PrimaryMembersGroup, MembersGroup } from "../../../types/models/MembersGroup";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const MembersGroupScoped = () => {
    const {
        data,
    } = useGetMembersGroupQuery(PrimaryMembersGroup.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/members-groups/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default MembersGroupScoped;
